<div class="flex w-full justify-content-center min-w-0">
  <div class="p-4 flex-shrink-1 max-w-full" #embeddedElement>
    @if (loading()) {
      <div class="w-full min-h-full flex justify-content-center align-items-center flex-column">
        <p class="text-gray-500 text-center text-lg mt-3" i18n>Loading availability...</p>
      </div>
    } @else if (error()) {  
      <div class="h-full">
        <div class="flex justify-center items-center h-full">
          <div class="text-center">
            <h1 class="text-2xl font-bold" i18n>Unable to load availability</h1>
            <p class="text-gray-500" i18n>Please try again later.</p>
            <app-request-id class="block mt-2" [requestId]="errorReference()"></app-request-id>
          </div>
        </div>
      </div>
    } @else if (clubStore.club() && !error()) {  
      <div class="h-full" *ngIf="courtAvailabilityConfig() as courtAvailabilityConfig">
        <cs-courts-availability [config]="courtAvailabilityConfig" [clubStore]="clubStore" [embedded]="true" class="w-min-0"></cs-courts-availability> <!-- [embedded]="true" -->
      </div>
    }
  </div>
</div>
